import React, {useContext, useEffect, useState} from "react";
import {observer} from "mobx-react";
import {Button, CircularProgress} from "@material-ui/core";
import {BackButton, Paper, Typography} from "../../../../../common/components/libs";
import OrdersStoreContext from "../store/context";
import {useStores} from "../../../../../hooks";
import styled from "styled-components";
import {spacing} from "@material-ui/system";
import moment from "moment";
import {SnackbarType} from "../../../../../stores/common";
import {useHistory, useParams} from "react-router-dom";
import {OrderStatus} from "../../../../../services/orders/models";
import {localize} from "../../../../../common/libs";
import {PaymentProviderType} from "../../../../../services/general/models";
import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator
} from '@material-ui/lab';
import Helmet from "react-helmet";
import {useTranslation} from "react-i18next";
import style from "./style.module.css"
import {DeliveryType} from "../../../../../services/menu/models";


const Spacer = styled.div(spacing);

const ShowDetailsForm = () => {
    const {i18n, t} = useTranslation(["general", "orders"]);
    const ordersStore = useContext(OrdersStoreContext);
    const {constantsStore, generalStore} = useStores();
    const [isReturningMoneyInProgress, setIsReturningMoneyInProgress] = useState(false);
    const history = useHistory();
    const filter = ordersStore.filter;
    const {orderId} = useParams<{ orderId: string }>();
    const order = ordersStore.currentOrder;

    useEffect(() => {
        let idNumber = parseInt(orderId)
        ordersStore.getOrder({orderId: idNumber});
        generalStore.setPageTitle(
            `Детали заказа №${orderId}`
        );
    }, [generalStore, orderId, ordersStore]);


    if (!order) {
        return null;
    }

    const returnMoney = async () => {
        setIsReturningMoneyInProgress(true);
        const id = {
            orderId: order.id
        }
        const returnResponse = await ordersStore.returnPayment(id);
        if (!returnResponse) {
            const params: ({ type: SnackbarType, title: string, description?: string }) = {
                title: t("general:somethingWentWrong"),
                type: SnackbarType.error,
                description: t("general:tryAgain")
            }
            generalStore.showSnackbar(params);
        } else {
            ordersStore.getOrders(filter);
            setIsReturningMoneyInProgress(false);
            generalStore.showSuccessSnackbar(t("orders:refundMade"));
            history.push(`/stats/list`);
        }
    }

    const currencyFormatter = constantsStore.getCurrencyFormatter(order.totalPrice.currencyId);
    return (
        <>
            <Helmet title={t("orders:orderDetails")}/>
            <BackButton to={"/stats/list"}/>
            <Paper className={style.commonDetails}>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("orders:orderData")}
                    </Typography>
                    <Typography component='h6' variant='body1'>
                        {moment(order.createdAt).format("DD.MM.YYYY HH:mm")}
                    </Typography>
                </div>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("orders:orderSum")}
                    </Typography>
                    <Typography component='h6' variant='body1'>
                        {currencyFormatter.toShowFormatted(order.totalPrice.price)}
                    </Typography>
                </div>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("orders:deliveryType")}
                    </Typography>
                    <Typography component='h6' variant='body1'>
                        {t(`orders:deliveryTypes.${order.deliveryDetails.type}`)}
                    </Typography>
                </div>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("orders:paymentType")}
                    </Typography>
                    <Typography component='h6' variant='body1'>
                        {t(`orders:paymentProviderType.${order.paymentDetails.type}`)}
                    </Typography>
                </div>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("orders:paymentState")}
                    </Typography>
                    {(!order.paymentDetails.isPaid && order.status !== OrderStatus.canceledWithRefund && order.paymentDetails.type === PaymentProviderType.cloudpayments) &&
                        <Typography component='h6' variant='body1' style={{color: '#f57c00'}}>
                            {t("orders:notPaid")}
                        </Typography>
                    }
                    {(order.paymentDetails.isPaid && order.status !== OrderStatus.canceledWithRefund && order.paymentDetails.type === PaymentProviderType.cloudpayments) &&
                        <Typography component='h6' variant='body1' style={{color: '#388e3c'}}>
                            {t("orders:paid")}
                        </Typography>
                    }
                    {(order.status !== OrderStatus.canceledWithRefund && order.paymentDetails.type === PaymentProviderType.companyInvoice || order.paymentDetails.type === PaymentProviderType.offline || order.paymentDetails.type === PaymentProviderType.toBankCard) &&
                        <Typography component='h6' variant='body1'>
                            -
                        </Typography>
                    }
                    {(order.status === OrderStatus.canceledWithRefund) &&
                        <Typography component='h6' variant='body1' style={{color: '#dc004e'}}>
                            {t("orders:return")}
                        </Typography>
                    }
                </div>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("orders:statusOfOrder")}
                    </Typography>
                    <Typography component='h6' variant='body1'>
                        {t(`orders:orderStatus.${order.status}`)}
                    </Typography>
                </div>

                {((order.deliveryDetails.type === DeliveryType.toAddress ||
                        order.deliveryDetails.type === DeliveryType.takeaway ||
                        order.deliveryDetails.type === DeliveryType.takeAwayToTime) && order.deliveryDetails?.name) &&
                    <div className={style.detailsBlock}>
                        <Typography component='h6' variant='body2'>
                            {t("general:clientName")}
                        </Typography>
                        <Typography component='h6' variant='body1'>
                            {order.deliveryDetails.name}
                        </Typography>
                    </div>
                }


                {((order.deliveryDetails.type === DeliveryType.toAddress ||
                        order.deliveryDetails.type === DeliveryType.takeaway ||
                        order.deliveryDetails.type === DeliveryType.takeAwayToTime ||
                        order.deliveryDetails.type === DeliveryType.toVehicle) &&  order.deliveryDetails?.phoneNumber) &&
                    <div className={style.detailsBlock}>
                        <Typography component='h6' variant='body2'>
                            {t("menu:orderSettingsPage.telephone")}
                        </Typography>
                        <Typography component='h6' variant='body1'>
                            {order.deliveryDetails.phoneNumber}
                        </Typography>
                    </div>
                }


                {(order.deliveryDetails.type === DeliveryType.toAddress) &&
                    <div className={style.detailsBlock}>
                        <Typography component='h6' variant='body2'>
                            {t("general:address")}
                        </Typography>
                        <Typography component='h6' variant='body1'>
                            {order.deliveryDetails.address}
                        </Typography>
                    </div>
                }
                {(order.deliveryDetails.type === DeliveryType.toAddress &&
                        (order.deliveryDetails.building || order.deliveryDetails.floor || order.deliveryDetails.flat)) &&
                    <div className={style.detailsBlock}>
                        <Typography component='h6' variant='body2'>
                            {t("general:building")} /  {t("general:floor")} /  {t("general:flat")}
                        </Typography>
                        <Typography component='h6' variant='body1'>
                            {order.deliveryDetails.building ? order.deliveryDetails.building : "-"} /
                            {order.deliveryDetails.floor ? order.deliveryDetails.floor : "-"} /
                            {order.deliveryDetails.flat ? order.deliveryDetails.flat : "-"}
                        </Typography>
                    </div>
                }


                {(order.deliveryDetails.type === DeliveryType.toVehicle && order.deliveryDetails.vehicleBrandName &&
                        order.deliveryDetails.vehicleColor && order.deliveryDetails.vehiclePlateNumber) &&
                    <div className={style.detailsBlock}>
                        <Typography component='h6' variant='body2'>
                            {t("general:car")}
                        </Typography>
                        <Typography component='h6' variant='body1'>
                            {`${order.deliveryDetails.vehicleBrandName + " "+ order.deliveryDetails.vehicleColor + " "+ order.deliveryDetails.vehiclePlateNumber}`}
                        </Typography>
                    </div>
                }


                {(order.deliveryDetails.type === DeliveryType.toTable && order.deliveryDetails.seatId) &&
                    <div className={style.detailsBlock}>
                        <Typography component='h6' variant='body2'>
                            {t("orders:deliveryTypes.ToRestaurantTable")}
                        </Typography>
                        <Typography component='h6' variant='body1'>
                            {order.deliveryDetails.seatId}
                        </Typography>
                    </div>
                }


                {(order.deliveryDetails.type === DeliveryType.takeAwayToTime) &&
                    <div className={style.detailsBlock}>
                        <Typography component='h6' variant='body2'>
                            {t("orders:deliveryTypes.TakeAwayToTime")}
                        </Typography>
                        <Typography component='h6' variant='body1'>
                            {order.deliveryDetails.date ? moment(order.deliveryDetails.date).format("DD.MM") + " "  : ""}
                            {order.deliveryDetails.toHour ? order.deliveryDetails.toHour : ""}
                            {order.deliveryDetails.toHour ? ":" : ""}
                            {(order.deliveryDetails.toMinute && order.deliveryDetails.toMinute < 10) ? "0"+ order.deliveryDetails.toMinute : order.deliveryDetails.toMinute}
                        </Typography>
                    </div>
                }

                <Spacer mb={6}/>
                {(order.paymentDetails.isPaid && !isReturningMoneyInProgress && order.status !== OrderStatus.canceledWithRefund) &&
                    <Button
                        onClick={() => {
                            returnMoney()
                        }}
                        color="primary"
                    >
                        {t("orders:returnMoney")}
                    </Button>
                }
                {(isReturningMoneyInProgress) &&
                    <Button
                        color="primary"
                        disabled
                    >
                        <CircularProgress
                            size={25}
                            color="secondary"
                        />
                    </Button>
                }
            </Paper>
            <Typography component='h4' variant='h4' mb={2} mt={6}>
                {t("orders:orderList")}
            </Typography>
            <Paper className={style.contain}>
                {order.items.map((orderItem) => {
                    return (
                        <div style={{margin: "10px"}}>
                            <div className={style.commonDetailsBlock}>
                                <Typography component='h6' variant='body1'>
                                    {localize(orderItem.menuItem.data.name)} x {orderItem.menuItemsCount}
                                </Typography>
                                <Typography component='h6' variant='body1'>
                                    {currencyFormatter.toShowFormatted(orderItem.price.price)}
                                </Typography>
                            </div>
                            {
                                orderItem.chosenMenuItemModifierSets.map((menuItemModifierSet) => {
                                    return (
                                        <div>
                                            {menuItemModifierSet.chosenMenuItemModifiers.map((chosenMenuItemModifier) => {
                                                const modifier = menuItemModifierSet.data.modifiers.find(modifierItem => modifierItem.id === chosenMenuItemModifier.menuItemModifierId)
                                                return (
                                                    <div className={style.commonDetailsBlock} style={{marginLeft: 10}}>
                                                        <Typography component='h6' variant='subtitle1'
                                                                    color='textSecondary'>
                                                            {localize(modifier.data.name)} x {chosenMenuItemModifier.count}
                                                        </Typography>
                                                        <Typography component='h6' variant='subtitle1'
                                                                    color='textSecondary'>
                                                            {currencyFormatter.toShowFormatted(modifier.data.sellPrice.price)}
                                                        </Typography>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )
                })
                }
            </Paper>
            <Typography component='h4' variant='h4' mb={2} mt={10}>
                {t("orders:orderHistory")}
            </Typography>
            <Paper className={style.history}>
                {order.statusHistory.map((statusDetail, index) => {
                        return (
                            <div style={{margin: "15px"}}>
                                <Timeline align='alternate'>
                                    <TimelineItem>
                                        <TimelineOppositeContent>
                                            {moment(statusDetail.changedAt).format("DD.MM.YYYY HH:mm")}
                                        </TimelineOppositeContent>

                                        <TimelineSeparator>
                                            <TimelineDot/>
                                            {
                                                order.statusHistory.length - 1 > index && <TimelineConnector/>
                                            }
                                        </TimelineSeparator>

                                        <TimelineContent>
                                            {t(`orders:orderStatus.${statusDetail.toStatus}`)}
                                        </TimelineContent>
                                    </TimelineItem>
                                </Timeline>
                            </div>
                        )
                    }
                )}
            </Paper>
        </>
    );

}

export default observer(ShowDetailsForm);
